// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-Summary {\n  box-shadow: 0 1px 4px 0 rgba(40, 51, 63, 0.14);\n  background-color: #FFFFFF;\n}\n@media screen and (min-width: 1025px) {\n  .x-Summary {\n    margin: -25px 15px;\n  }\n}\n.x-Summary-content {\n  padding: 11px 11px;\n}\n@media screen and (min-width: 1000px) {\n  .x-Summary-content {\n    padding: 11px 81px;\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"root": "x-Summary",
	"content": "x-Summary-content"
};
module.exports = exports;
